import { CheckBoxWidget } from '@tableau/widgets';
import * as React from 'react';

import { Conditional } from '../../../common/react/components/Conditional';
import { ExplorableItemDefinitions } from '../../../ts/models/ContentDefinitions';
import { getKeyForExplorableItem } from '../../../ts/models/ContentType';
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { ExploreContentApi_ContentType } from '../../../ts/ServerApi/types/IContent';
import { Hover } from '../Components/Hover';
import { SpacesSiteUrls } from '../SpacesSiteUrls';
import { CardViewStyles } from './CardViewStyles';
import { ContentCardProps } from './ContentCard';
import { GenericCard } from './GenericCard';

export interface ContentCardWrapperStateProps {
  urls: SpacesSiteUrls;
  inWorkbookDatasourcesSubspace: boolean;
  inDatasourceConnectionsSubspace: boolean;
}

export interface ContentCardWrapperDispatchProps {
  readonly addContentFavorite: (contentId: string, contentType: ExploreContentApi_ContentType) => any;
  readonly removeContentFavorite: (contentId: string, contentIdForFavoriting: string, contentType: ExploreContentApi_ContentType, contentName: string) => any;
  readonly getContentDetail: (content: IContentInfo) => void;
}

export interface ContentCardWrapperOwnProps {
  readonly content: IContentInfo;
  readonly showActionMenu: boolean;
  readonly selected?: boolean;
  readonly toggleSelection?: (content: IContentInfo) => void;
}

export type ContentCardWrapperProps = ContentCardWrapperOwnProps & ContentCardWrapperStateProps & ContentCardWrapperDispatchProps;

export interface ContentCardWrapperState {
  isHovered: boolean;
}

type InnerCardProps = React.Attributes & ContentCardProps;

// Make sure the checkbox is absolutely positioned with respect to the proper bounds
const CardOuterStyle: React.CSSProperties = {
  position: 'relative',
};

export class ContentCardWrapper extends React.PureComponent<ContentCardWrapperProps, ContentCardWrapperState> {
  constructor(props: ContentCardWrapperProps) {
    super(props);
    this.state = {
      isHovered: false
    };
  }
  private chooseInnerCardType = (content: IContentInfo): JSX.Element => {
    const cardProps: InnerCardProps = {
      key: getKeyForExplorableItem(content),
      content: content,
      selected: this.props.selected,
      urls: this.props.urls,
      addContentFavorite: this.props.addContentFavorite,
      removeContentFavorite: this.props.removeContentFavorite,
      getContentDetail: this.props.getContentDetail,
      inWorkbookDatasourcesSubspace: this.props.inWorkbookDatasourcesSubspace,
      inDatasourceConnectionsSubspace: this.props.inDatasourceConnectionsSubspace,
      showActionMenu: this.props.showActionMenu,
    };

    const contentDefinition = ExplorableItemDefinitions[content.contentType];
    let Card = contentDefinition ? contentDefinition.cardComponent : GenericCard;

    if (Card) {
      return <Card {...cardProps} />;
    } else {
      // No card component exists for some content types (e.g. flow output).
      return null;
    }
  }

  public render() {

    const testId = `${this.props.content.contentType}-${this.props.content.id}-card`;

    return (
      <div data-tb-test-id={testId} style={CardOuterStyle}>
        <Hover groupName="content-card-select" onEnter={this.activateHover} onLeave={this.deactivateHover}>
          <Conditional showIf={this.props.selected || this.state.isHovered}>
            <span className={CardViewStyles.SelectCheckbox}>
              {this.props.toggleSelection &&
                <CheckBoxWidget checked={this.props.selected}
                                handleChange={this.toggleSelection}
                                testId="selection-checkbox"/>
              }
            </span>
          </Conditional>

          {React.cloneElement(React.Children.only(this.chooseInnerCardType(this.props.content)), {
            hoveredOrSelected: this.props.selected || this.state.isHovered
          })}
        </Hover>
      </div>
    );
  }

  private toggleSelection = () => this.props.toggleSelection(this.props.content);

  private activateHover = () => {
    this.setState({isHovered: true});
  }

  private deactivateHover = () => {
    this.setState({isHovered: false});
  }
}
